export default __webpack_public_path__ + "static/media/background-plant3.86901a8e.png";